import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "+916289854719";
export const BUSINESS_PHONE = "+916289854719";
export const BUSINESS_EMAIL = "apurbaestate@gmail.com";
export const OFFICE_LOCATION = "Budge Budge · Alipore · South 24 Parganas, West Bengal";
export const COVERAGE_OFFICES = [
  "Budge Budge II BL&LRO",
  "Alipore SDLRO",
  "District Offices, South 24 Parganas",
];

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ae_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export function formatPrice(value) {
  if (value == null) return "";
  if (value >= 10000000) return `₹ ${(value / 10000000).toFixed(2)} Cr`;
  if (value >= 100000) return `₹ ${(value / 100000).toFixed(2)} L`;
  return `₹ ${value.toLocaleString("en-IN")}`;
}

export function formatArea(value, unit) {
  if (!value) return "";
  const u = unit || "";
  return `${value} ${u}`;
}

export function whatsappLink(message) {
  const text = encodeURIComponent(message || "Hello Apurba Estate, I would like to enquire about your services.");
  const number = WHATSAPP_NUMBER.replace(/\D/g, "");
  return `https://wa.me/${number}?text=${text}`;
}

export function telLink() {
  return `tel:${BUSINESS_PHONE}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const PROPERTY_TYPES = [
  { value: "residential_land", label: "Residential Land" },
  { value: "agricultural_land", label: "Agricultural Land" },
  { value: "flat", label: "Flat / Apartment" },
  { value: "house", label: "Independent House" },
  { value: "commercial", label: "Commercial Space" },
  { value: "investment", label: "Investment Property" },
];

export const SERVICE_AREAS = [
  "Budge Budge", "Budge Budge II", "Alipore", "Pujali", "Nodakhali",
  "Bawali", "Amtala", "Bishnupur", "Diamond Harbour", "Falta", "South 24 Parganas",
];
